module.exports = __webpack_public_path__ + "static/img/hxcj.96787ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hxcj.png
// module id = edoR
// module chunks = 1